import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { AppShell } from './modules/layout'
import { NotFoundPage } from './modules/layout/ui/components/NotFoundPage'
import { ScrollToTop } from './lib/ScrollToTop'
import { MobileMenuDrawer } from './modules/layout/ui/components/MobileMenuDrawer'
import { HomePage } from './modules/home'
import { LoginPage, RegisterPage } from './modules/auth'
import { AccountPage, MyOrdersPage } from './modules/account'
import { WarrantyPage, ReturnPage, BuyingGuidePage, ShippingPage, FaqPage, AboutPage, StoresPage, CareersPage, TermsPage, PrivacyPage, SitemapPage } from './modules/static-pages'
import { SearchPage } from './modules/search'
import {
  AdminShell, AdminGuard, AdminLoginPage, AdminPlaceholder,
  DashboardPage, ProductsListPage, ProductFormPage, CategoriesListPage,
  OrdersListPage, OrderDetailPage, AdminPromoPage,
  ArticlesListPage, ArticleFormPage, SettingsPage, ToastContainer, VouchersListPage, ArticleCategoriesPage,
} from './modules/admin'

const ProductsPage      = lazy(() => import('./modules/products').then((m) => ({ default: m.ProductsPage })))
const ProductDetailPage = lazy(() => import('./modules/products').then((m) => ({ default: m.ProductDetailPage })))
const CartPage          = lazy(() => import('./modules/cart').then((m) => ({ default: m.CartPage })))
const CheckoutPage      = lazy(() => import('./modules/checkout').then((m) => ({ default: m.CheckoutPage })))
const OrderSuccessPage  = lazy(() => import('./modules/checkout').then((m) => ({ default: m.OrderSuccessPage })))
const NewsPage          = lazy(() => import('./modules/news').then((m) => ({ default: m.NewsPage })))
const PromoPage         = lazy(() => import('./modules/promo').then((m) => ({ default: m.PromoPage })))
const ContactPage       = lazy(() => import('./modules/contact').then((m) => ({ default: m.ContactPage })))

function PageSkeleton() {
  return (
    <div className="max-w-[1440px] mx-auto px-6 py-10">
      <div className="h-6 w-40 bg-slate-200 rounded animate-pulse" />
      <div className="mt-5 h-80 bg-slate-100 border border-border rounded-xl animate-pulse" />
    </div>
  )
}

function ClientRoutes() {
  return (
    <AppShell>
      <ScrollToTop />
      <MobileMenuDrawer />
      <Suspense fallback={<PageSkeleton />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/danh-muc/:slug" element={<ProductsPage />} />
          <Route path="/san-pham/:slug" element={<ProductDetailPage />} />
          <Route path="/gio-hang" element={<CartPage />} />
          <Route path="/thanh-toan" element={<CheckoutPage />} />
          <Route path="/dat-hang-thanh-cong" element={<OrderSuccessPage />} />
          <Route path="/tin-tuc" element={<NewsPage />} />
          <Route path="/tin-tuc/:slug" element={<NewsPage />} />
          <Route path="/khuyen-mai" element={<PromoPage />} />
          <Route path="/lien-he" element={<ContactPage />} />
          <Route path="/tai-khoan" element={<AccountPage />} />
          <Route path="/don-hang"  element={<MyOrdersPage />} />
          <Route path="/tim-kiem" element={<SearchPage />} />
          <Route path="/chinh-sach-bao-hanh" element={<WarrantyPage />} />
          <Route path="/chinh-sach-doi-tra" element={<ReturnPage />} />
          <Route path="/chinh-sach-giao-hang" element={<ShippingPage />} />
          <Route path="/huong-dan-mua-hang" element={<BuyingGuidePage />} />
          <Route path="/cau-hoi-thuong-gap" element={<FaqPage />} />
          <Route path="/gioi-thieu" element={<AboutPage />} />
          <Route path="/he-thong-cua-hang" element={<StoresPage />} />
          <Route path="/tuyen-dung" element={<CareersPage />} />
          <Route path="/dieu-khoan" element={<TermsPage />} />
          <Route path="/chinh-sach-bao-mat" element={<PrivacyPage />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/dang-nhap" element={<LoginPage />} />
          <Route path="/dang-ky" element={<RegisterPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </AppShell>
  )
}

function AdminRoutes() {
  return (
    <AdminGuard>
      <AdminShell>
        <ScrollToTop />
        <Routes>
          <Route index                element={<DashboardPage />} />
          <Route path="san-pham"      element={<ProductsListPage />} />
          <Route path="san-pham/moi"  element={<ProductFormPage />} />
          <Route path="san-pham/:id"  element={<ProductFormPage />} />
          <Route path="danh-muc"      element={<CategoriesListPage />} />
          <Route path="don-hang"      element={<OrdersListPage />} />
          <Route path="don-hang/:id"  element={<OrderDetailPage />} />
          <Route path="chuyen-muc-tin-tuc" element={<ArticleCategoriesPage />} />
            <Route path="voucher" element={<VouchersListPage />} />
            <Route path="khuyen-mai"    element={<AdminPromoPage />} />
          <Route path="tin-tuc"       element={<ArticlesListPage />} />
          <Route path="tin-tuc/moi"   element={<ArticleFormPage />} />
          <Route path="tin-tuc/:id"   element={<ArticleFormPage />} />
          <Route path="cai-dat" element={<SettingsPage />} />
        </Routes>
      </AdminShell>
    </AdminGuard>
  )
}

function GenericPage({ title }: { title: string }) {
  return (
    <div className="max-w-[1440px] mx-auto px-6 py-16 text-center">
      <h1 className="text-2xl font-bold text-text mb-2">{title}</h1>
      <p className="text-muted">Trang đang được xây dựng. Vui lòng quay lại sau.</p>
    </div>
  )
}

export function AppRouter() {
  return (
    <>
      <Routes>
        <Route path="/admin/dang-nhap" element={<AdminLoginPage />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/*" element={<ClientRoutes />} />
      </Routes>
      <ToastContainer />
    </>
  )
}
